import * as R from 'ramda'

export const setQueryParams = (state, action) => {
  const { payload } = action
  return R.assoc('queryParams', payload, state)
}

export const setQueryParam = (state, action) => {
  const { payload } = action
  const { param, value } = payload
  return R.assocPath(['queryParams', param], value, state)
}

export const omitQueryParam = (state, action) => {
  const { payload: param } = action
  return R.dissocPath(['queryParams', param], state)
}

export const setPath = (state, action) => {
  const { payload } = action
  return R.assoc('pathname', payload, state)
}
